import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import UserAllAddress from '../../Components/User/UserAllAddress'
import UserSideBar from '../../Components/User/UserSideBar'

const UserAllAddresPage = () => {
    return (
        <div className="cart-page-bg font">
            <Container>
                <Row className='g-4 py-4'>
                    <Col lg="3" md="4" xs="12">
                        <UserSideBar />
                    </Col>
                    <Col lg="9" md="8" xs="12">
                        <UserAllAddress />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default UserAllAddresPage

